/** Tokens visuais — inscrições (marca TNV) */
export const INSCRICAO_ACCENT = "#F96030";
export const INSCRICAO_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";
export const INSCRICAO_INK = "#1a2035";

export const sectionCardSx = {
  p: 2.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
  height: "100%",
};

export const detailHeaderSx = {
  px: { xs: 2, md: 3 },
  py: 2.5,
  background: `linear-gradient(135deg, ${INSCRICAO_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${INSCRICAO_ACCENT}`,
};
